<template>
  <div class="p-6">
    <div class="flex gap-1">
      <div class="h-full bg-white bordre rounded-xl border border-slate-200">
        <ImportSourceTypeMenu />
      </div>
      <div class="flex-1 w-full">
        <SearchesList />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ImportSourceTypeMenu from "./SourcesList/ImportSourceTypeMenu.vue";
import SearchesList from "./SearchesList/SearchesList.vue";
</script>
<style>
.source-highlight {
  animation: flash-card 2.5s ease-in-out;
}

@keyframes flash-card {
  0% {
    background-color: #ffffff;
  }

  25% {
    background-color: #dcfce7;
  }

  75% {
    background-color: #dcfce7;
  }

  100% {
    background-color: #ffffff;
  }
}
</style>
